import { type User } from '@avanta/shared/types/users';

export const getUserDisplayName = (user: User | null | undefined): string =>
  user?.nickname || user?.name || user?.firstName || user?.email || '';
